@if (bas.envtest) {
  <div class="text-center">
    goto.page (test)
  </div>
}
